import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SmsHelper {

  constructor() { }

  formatPhoneNumber(phoneNumber: string): string {
    if (phoneNumber.indexOf('+') > -1) {
      return phoneNumber.substr(1);
    }
    return phoneNumber;
  }
}
